<template>
  <div class="layout" :class="{ 'fixed-side': fixedMenu, 'hide-side': !fixedMenu }">
    <div class="layout-header">
      <layout-header @open="openSide" @refresh="refresh" />
    </div>

    <div class="layout-main">
      <div class="layout-side" :style="sizeStyle">
        <layout-side ref="side-menu" :collapse="collapse" :size-style="sizeStyle" @choose-menu="closeSide" @size-change="setSideMenuHeight" />
      </div>
      <div ref="app" v-loading="loading" class="layout-app">
        <layout-crumbs v-if="!$route.meta.hiddenCrumbs" @refresh="refresh" />
        <!-- <TagsView @refresh="refresh" /> -->
        <transition name="fade-transform" mode="out-in">
          <keep-alive :include="cachedViews">
            <router-view v-if="!refreshing" :key="routeKey" />
          </keep-alive>
        </transition>
      </div>
    </div>

    <div class="layout-footer">
      <layout-footer />
    </div>
  </div>
</template>

<script>
import LayoutHeader from './header/layout-header.vue'
import LayoutFooter from './footer/layout-footer.vue'
import LayoutSide from './side-menu/layou-side.vue'
import LayoutCrumbs from './crumbs/layout-crumbs'
// import TagsView from './tags-view/index.vue'
import debounce from 'throttle-debounce/debounce'

import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event'

export default {
  name: 'Layout',
  componentName: 'Layout',
  components: {
    LayoutHeader,
    LayoutFooter,
    LayoutSide,
    LayoutCrumbs
    // TagsView
  },
  data() {
    return {
      collapse: true,
      sideHeight: 0,
      refreshing: false
    }
  },
  computed: {
    routeKey() {
      return this.$route.path
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    loading() {
      return this.$store.getters.loading
    },
    fixedMenu() {
      return this.$store.getters.fixedMenu
    },
    synchronousHeight() {
      return this.fixedMenu || !this.collapse
    },
    sizeStyle() {
      return {
        height: `${this.sideHeight}px`
      }
    }
  },
  watch: {
    synchronousHeight() {
      setTimeout(this.setSideMenuHeight(), 100)
    }
  },
  created() {
    this.$store.dispatch('menu/getQuickRecord')
    this.$store.dispatch('app/getUserInfo')
    this.$store.dispatch('app/getGuideInfo')

    this.$on('layout.refresh', () => {
      this.refresh()
    })
  },
  mounted() {
    addResizeListener(this.$refs.app, this.resize)
    window.addEventListener('scroll', this.scroll)
    this.setSideMenuHeight()
  },
  beforeDestroy() {
    removeResizeListener(this.$refs.app, this.resize)
    window.removeEventListener('scroll', this.scroll)
  },
  methods: {
    // 监听滚动
    scroll() {
      const { scrollTop, clientHeight, scrollHeight } = document.documentElement
      const scrollBottom = scrollHeight - clientHeight - scrollTop
      const position = { scrollTop: scrollTop, scrollBottom, atBottom: scrollBottom <= 45 }
      this.$store.commit('app/SET_POSITION', position)
    },
    // 监听整个app的大小
    resize: debounce(200, function() {
      const size = {
        documentWidth: document.documentElement.scrollWidth,
        documentHeight: document.documentElement.scrollHeight,
        appWidth: this.$refs.app.clientWidth,
        appHeight: this.$refs.app.clientHeight
      }
      this.$store.commit('app/SET_APPSIZE', size)
      this.setSideMenuHeight()
    }),
    // 设置侧边栏的高度
    async setSideMenuHeight() {
      if (this.synchronousHeight) {
        this.sideHeight = Math.max(this.$refs['side-menu'].sideHeight, this.$refs.app.scrollHeight)
      } else {
        this.sideHeight = 0
      }
      await this.$nextTick()
      this.scroll()
    },
    // 展开左侧菜单
    openSide() {
      if (!this.collapse) return
      this.collapse = false
      // 展开动画结束后添加事件
      setTimeout(() => {
        document.addEventListener('click', this.closeSide)
      }, 300)
    },
    // 点击任意位置关闭侧边栏
    closeSide(e) {
      if (e.target && this.$refs['side-menu'].$el.contains(e.target)) return
      this.collapse = true
      document.removeEventListener('click', this.closeSide)
    },
    // 刷新页面
    refresh() {
      // if (this.refreshing) return
      // this.refreshing = true
      // this.$nextTick(() => {
      //   this.refreshing = false
      // })
      this.refreshByrouter()
    },
    refreshByrouter: debounce(300, function() {
      const view = this.$route
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          })
        })
      })
    })
  }
}
</script>

<style lang="scss" scoped>
/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all .3s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.layout {
  min-height: 100vh;
  padding-top: 50px;
  box-sizing: border-box;
  background: #F3F5F6;
  &-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    box-shadow: 0px 5px 13px 0px rgba(106, 106, 106, 0.06);
    z-index: 100;
  }
  &-main {
    position: relative;
    box-sizing: border-box;
    min-height: calc(100vh - 95px);
    // padding: 10px;
    overflow: hidden
  }
  &-side {
    position: relative;
    z-index: 10;
    display: inline-block;
    vertical-align: top;
    width: 0;
    transition: all .3s;
  }
  &-app {
    display: inline-block;
    box-sizing: border-box;
    padding: 12px;
    vertical-align: top;
    width: 100%;
    min-height: calc(100vh - 95px);
    transition: all .3s;
  }
  &.fixed-side {
    .layout-side {
      width: 230px;
      background: #fff;
    }
    .layout-app {
      width: calc(100% - 230px);
    }
  }
  &-footer {
    height: 45px;
  }
}
</style>
